<template>
  <div>
    <div class="page-header clear-filter" filter-color="white">
      <parallax
        class="page-header-image"
        style="background-image:url('img/berlin-3190651.jpg')"
      >

      </parallax>
      <div class="container">
        <div class="content-center brand">
          <img src="img/logo.png" width="50%" alt="" />
          <h1 class="h1-seo"></h1>
          <h3></h3>
        </div>

      <div class='icon-scroll'></div>
      </div>
    </div>





      <div class="container">
        <div class="row text-align:center">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h1 class="title">Right place. Right time.</h1>
            <h4 class="description">
             Knowing about large groups of people attending specific events enables companies to pitch their offerings effectively.
            </h4>
          </div>
        </div>
      </div>

      <div class="separator separator-primary"></div>

      <!--
      <div class="row">
        <div class="col-lg-6 mobile-50" style="background-color:#386576; color:white">
          <div class="border-text">
            <h2 class="title">
              Why does this matter?
            </h2>
            <h4>
              Crowdify increases the probability to deliver a service at the right place, at the right time. This capability can significantly increase revenue. It is not enough to know about the location itself. You need to know when your customers are actually there!
            </h4>
          </div>
        </div>
        <div class="col-lg-3 mobile-50" style="background-color:#C6D3DF; display:flex; justify-content:center; align-items:center;">
          <img class="reduce-image-size"  src="img/football-stadium-empty_form.png">
        </div>
        <div class="col-lg-3 mobile-50" style="background-color:#C6D3DF; display:flex; justify-content:center; align-items:center;">
          <img class="reduce-image-size"  src="img/football-stadium-full_form.png">
        </div>
      </div>
      -->

      <div class="row">
        <div class="col-lg-7" style="background-color:#386576; color:white">
          <div class="border-text">
            <h2 class="title">
              Why does this matter?
            </h2>
            <h4>
              Crowdify increases the probability to deliver a service at the right place, at the right time. This capability can significantly increase revenue. It is not enough to know about the location itself. You need to know when your customers are actually there!
            </h4>
          </div>
        </div>
        <div class="col-lg-5" style="background-color:#C6D3DF; display:flex; justify-content:center; align-items:center; padding-left:50px; padding-right:50px">
          <div class="row">
            <div class="col">
              <img style="size:60%" src="img/football-stadium-empty_form.png">
            </div>
            <div class="col">
              <img style="size:60%"  src="img/football-stadium-full_form.png">
            </div>
          </div>
        </div>
      </div>




      <div class="container">
        <h1 class="title col-md-8 ml-auto mr-auto text-center">Benefits</h1>
      </div>

      <!--
      <div class="container text-center">
        <div class="row">
          <div class="col-12 col-md-8">
            <CarouselSectionVuetify/>
            <carousel-section></carousel-section>
          </div>
          <div class="col-xl-4" style="text-align:left"><h1>One API,<br> endless benefits</h1></div>
        </div>
      </div>
      -->

      <div class="row">
      <div class="container">
        <div class="col-md-12 col-12">
          <ListVuetify/>
        </div>
        </div>
      </div>





        <div class="row text-align:center">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h1 class="title" id="products">Products</h1>
            <h4 style="margin:20px">
             Use the Crowdify API for integrating events directly into your platform, or use the Crowdify Dashboard to gain a simplistic overview. The choice is yours!
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="col-sm" style="background-color:#FFFFFF; color:black">
            <div class="border-text">
              <h2 class="title">
              Dashboard
              </h2>
              <h4>
              Want to identify customer locations without having any technical resources? Simply browse using the Crowdify Dashboard!
              </h4>
              <div style="padding-top:30px">
                <v-btn
                  rounded
                  color="rgba(255, 255, 255, 0.7)"
                  to="/documentation/dashboard/start"
                >
                  Documentation
                </v-btn>
              </div>
            </div>
          </div>
          <div class="col-sm" style="background-color:#C6D3DF; display:flex; justify-content:center; align-items:center;">
            <video autoplay="" loop="" muted="" playsinline="" src="video/map_screencast.mp4" class="ax ay az ba bs ce">Ihr Browser unterstützt kein HTML5-Video.</video>
          </div>
        </div>



        <!-- screen >=lg -->
        <div class="d-none d-lg-block">
          <div class="row" style="min-height:600px">
            <div class="col-sm" style="background-color:#88B7B5; display:flex; justify-content:center; align-items:center; color:#FFFFFF">
                <div style="margin:20px; font-size:15px">
                  <div style="margin-bottom:30px">GET https://api.crowdify.io/v1/events</div>
                  <div>
                    <b>Header:</b>
                  </div>
                  <span>x-api-key</span>: YOUR BEARER TOKEN GOES IN HERE
                  <div style="margin-top:10px">
                    <b>Parameters:</b>
                  </div>
                  lat=<span class="value-css">53.5586941</span><br />
                  lng=<span class="value-css">9.7877397</span><br />
                  radius=<span class="value-css">20000</span><br />
                  start=<span class="value-css">2020-03-01</span><br />
                  end=<span class="value-css">2020-03-31</span><br />
                </div>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                  color="white"
                ></v-divider>
            </div>
            <div class="col-sm" style="background-color:#88B7B5; display:flex; justify-content:center; align-items:center; color:#FFFFFF">
            <div style="margin:20px; font-size:15px">
              <span class="highlight">"data"</span>: [ <br>
                <div style="margin-left:20px">
                  {<br>
                      <div style="margin-left:20px">
                        <span class="highlight">"title"</span>: "Vona", <br>
                        <span class="highlight">"category"</span>: "concert", <br>
                        <span class="highlight">"start_date"</span>: "2020-09-09T17:30:00Z", <br>
                        <span class="highlight">"end_date"</span>: "2020-09-09T20:00:00Z", <br>
                        <span class="highlight">"location"</span>: { <br>
                          <div style="margin-left:20px">
                            <span class="highlight">"coordinates"</span>: [ <br>
                                <div style="margin-left:20px">
                                  9.172502640006817,<br>
                                  48.804247000000004<br>
                                </div>
                            ],<br>
                            <span class="highlight">"name"</span>: "Freilichtbühne Killesberg"<br>
                          </div>
                        },<br>
                        <span class="highlight">"state"</span>: "active",<br>
                        <span class="highlight">"updated"</span>: "2020-08-29T14:00:58Z",<br>
                        <span class="highlight">"id"</span>: "fe534618526d40298f918b1ee76c9803"<br>
                      </div>
                  },<br>
                  ... <br>
                </div>
              ]
            </div>

              </div>

            <div class="col-sm" style="background-color:#FFFFFF; color:black">
              <div class="border-text">
                <h2 class="title">
                  One API - All Events
                </h2>
                <h4>
                  Want to aggregate Crowdify data with your own? Simply integrate the API snippet below and you're good to go!
                </h4>
                <div style="padding-top:30px">
                  <v-btn
                    rounded
                    color="rgba(255, 255, 255, 0.7)"
                    to="/documentation/api/start"
                  >
                    Documentation
                  </v-btn>
                </div>
              </div>
            </div>

          </div>
        </div> <!-- end: screen >=lg -->

        <!-- screen <lg -->
        <div class="d-lg-none">
          <div class="row" style="min-height:600px">

            <div class="col-sm" style="background-color:#FFFFFF; color:black">
              <div class="border-text">
                <h2 class="title">
                  One API - All Events
                </h2>
                <h4>
                  Want to aggregate Crowdify data with your own? Simply integrate the API snippet below and you're good to go!
                </h4>
                <div style="padding-top:30px">
                  <v-btn
                    rounded
                    color="rgba(255, 255, 255, 0.7)"
                    to="/documentation/api/start"
                  >
                    Documentation
                  </v-btn>
                </div>
              </div>
            </div>


            <div class="col-sm" style="background-color:#88B7B5; justify-content:center; align-items:center; color:#FFFFFF">
                <div style="margin:20px; font-size:15px">
                  <div style="margin-bottom:30px">GET https://api.crowdify.io/v1/events</div>
                  <div>
                    <b>Header:</b>
                  </div>
                  <span>authorizationToken</span>: YOUR BEARER TOKEN GOES IN HERE
                  <div style="margin-top:10px">
                    <b>Parameters:</b>
                  </div>
                  lat=<span class="value-css">53.5586941</span><br />
                  lng=<span class="value-css">9.7877397</span><br />
                  radius=<span class="value-css">20000</span><br />
                  start=<span class="value-css">2020-03-01</span><br />
                  end=<span class="value-css">2020-03-31</span><br />
                </div>
                <v-divider
                  class="mx-4"
                  inset
                  color="white"
                ></v-divider>
                <div style="margin:20px; font-size:15px">
                  <span class="highlight">"data"</span>: [ <br>
                    <div style="margin-left:20px">
                      {<br>
                          <div style="margin-left:20px">
                            <span class="highlight">"title"</span>: "Vona", <br>
                            <span class="highlight">"category"</span>: "concert", <br>
                            <span class="highlight">"start_date"</span>: "2020-09-09T17:30:00Z", <br>
                            <span class="highlight">"end_date"</span>: "2020-09-09T20:00:00Z", <br>
                            <span class="highlight">"location"</span>: { <br>
                              <div style="margin-left:20px">
                                <span class="highlight">"coordinates"</span>: [ <br>
                                    <div style="margin-left:20px">
                                      9.172502640006817,<br>
                                      48.804247000000004<br>
                                    </div>
                                ],<br>
                                <span class="highlight">"name"</span>: "Freilichtbühne Killesberg"<br>
                              </div>
                            },<br>
                            <span class="highlight">"state"</span>: "active",<br>
                            <span class="highlight">"updated"</span>: "2020-08-29T14:00:58Z",<br>
                            <span class="highlight">"id"</span>: "fe534618526d40298f918b1ee76c9803"<br>
                          </div>
                      },<br>
                      ... <br>
                    </div>
                  ]
                </div>

              </div>



          </div>
        </div> <!-- end: screen <lg -->

      <!--

      <div class="container" id="products">
        <h1 class="title col-md-8 ml-auto mr-auto text-center">Products</h1>
      </div>
      <div class="row">
      <div class="container">
        <div class="col-12 col-md-12">
          <h4>Use the Crowdify API for integrating events directly into your platform, or use the Crowdify Dashboard to gain a simplistic overview. The choice is yours!</h4>
          <EventExplorerTeaser/>
        </div>
        </div>
      </div>
      -->


      <!--
      <div id="cookieInformation" class="v-dialog v-dialog--active v-bottom-sheet" style="transform-origin: center center;">
        <div class="text-center v-sheet theme--light" style="height: 200px;">
          <div class="title">Consent Information</div>
          <div>This website uses cookies to ensure you get the best experience on our website.</div>
          <v-btn color="error" dark large>Got it</v-btn>
        </div>
      </div>
      -->




  </div>

</template>
<script>

import { Parallax } from '@/components';

import BasicElements from './components/BasicElementsSection';
import Navigation from './components/Navigation';
import TabsSection from './components/Tabs';
import ProgressPagination from './components/ProgressPagination';
import Notifications from './components/Notifications';
import Typography from './components/Typography';
import JavascriptComponents from './components/JavascriptComponents';
import CarouselSection from './components/CarouselSection0';
import CarouselSectionVuetify from './components/CarouselSectionVuetify';
import EventExplorerSection from './components/EventExplorerSection';
import EventExplorerSection0 from './components/APISection';
import EventExplorerTeaser from './components/EventExplorerTeaser';
import APISection from './components/APISection';
import SignupForm from './components/SignupForm';
import ExamplesSection from './components/ExamplesSection';
import DownloadSection from './components/DownloadSection';
import ListVuetify from './components/ListVuetify';

import { Auth } from 'aws-amplify'

//import Prism from 'prismjs';



export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    Parallax,
    BasicElements,
    Navigation,
    TabsSection,
    ProgressPagination,
    Notifications,
    Typography,
    JavascriptComponents,
    CarouselSection,
    CarouselSectionVuetify,
    EventExplorerSection,
    EventExplorerSection0,
    EventExplorerTeaser,
    SignupForm,
    ExamplesSection,
    APISection,
    DownloadSection,
    ListVuetify
  },

  created(){
    //document.cookie = "consentgiven=true"
    var x =  document.cookie
  }


};















</script>
<style>
@media (max-width: 800px) {
  .test{
    margin-top:50px;
  }
  .icon-scroll{
    width: 30px;
    height: 50px;
    margin-left: -20px;
    top: 60%;
    margin-top: -35px;
    box-shadow: inset 0 0 0 2px #fff;
    border-radius: 25px;
  }
}
@media (min-width: 801px) {
  .icon-scroll{
    width: 30px;
    height: 50px;
    margin-left: -20px;
    top: 85%;
    margin-top: -35px;
    box-shadow: inset 0 0 0 2px #fff;
    border-radius: 25px;
  }
}

@media only screen and (max-width: 960px) {
  .mobile-50 {height:100%}
  .reduce-image-size{
    height: 250px;
  }
}

@media only screen and (min-width: 961px) {
  .reduce-image-size{
    height: 100%;
  }
}





.icon-scroll,
.icon-scroll:before{
  position: absolute;
  left: 50%;
}

.icon-scroll:before{
  content: '';
  width: 8px;
  height: 8px;
  background: #fff;
  margin-left: -4px;
  top: 8px;
  border-radius: 4px;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-name: scroll;
}


.border-text{
  padding-top: 80px;
  padding-left: 50px;
  padding-right: 50px;
}

@keyframes scroll{
  0%{transform: translateY(25px); opacity: 1}
  100%{
    opacity: 0;
    transform: translateY(-15px);
  }
}

.highlight {
    color: #f92672;
}


</style>
